import { Pipe, PipeTransform } from '@angular/core';
import i18next from 'i18next';

@Pipe({
  name: 'valueData',
})
export class ValueDataPipe implements PipeTransform {
  to: string;
  constructor() {
    this.to = 'noData';
  }

  transform(value: string | null, to?: string): string {
    if (value && value.length > 0) {
      return value;
    }
    if (to) {
      return i18next.t(to);
    }
    return i18next.t('noData');
  }
}
